"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = void 0;
var react_1 = require("react");
/**
 * Use setTimeout with Hooks in a declarative way.
 *
 * @see https://stackoverflow.com/a/59274757/3723993
 * @see https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
function useTimeout(callback, delay) {
    var timeoutRef = (0, react_1.useRef)(null);
    var callbackRef = (0, react_1.useRef)(callback);
    // Remember the latest callback:
    //
    // Without this, if you change the callback, when setTimeout kicks in, it
    // will still call your old callback.
    //
    // If you add `callback` to useEffect's deps, it will work fine but the
    // timeout will be reset.
    (0, react_1.useEffect)(function () {
        callbackRef.current = callback;
    }, [callback]);
    // Set up the timeout:
    (0, react_1.useEffect)(function () {
        if (typeof delay === 'number') {
            timeoutRef.current = window.setTimeout(function () { return callbackRef.current(); }, delay);
            // Clear timeout if the components is unmounted or the delay changes:
            return function () { return window.clearTimeout(timeoutRef.current || 0); };
        }
    }, [delay]);
    // In case you want to manually clear the timeout from the consuming component...:
    return timeoutRef;
}
exports.useTimeout = useTimeout;
//# sourceMappingURL=useTimeout.js.map